// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media screen and (max-width:1023px){.frisbuy-widget .frisbuy-gallery-navigation{position:relative;height:-moz-fit-content;height:fit-content}.frisbuy-widget .frisbuy-gallery-navigation .frisbuy-guide-button{margin:12px 0 16px}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
